import { forwardRef } from 'react'
import Flex from '../Flex'
import { AppSectionProps } from './props'
import { StyledAppSection } from './styles'
import { Text } from '../../Atoms'

const AppSection = forwardRef<HTMLDivElement, AppSectionProps>(
    (
        {
            backgroundColor,
            borderColor,
            endContent,
            helperText,
            onClick,
            startContent,
            title,
        },
        ref
    ) => (
        <StyledAppSection ref={ref}>
            {title && (
                <Text
                    css={{
                        color: '$neutral500',
                        px: '$3',
                    }}
                >
                    {title}
                </Text>
            )}
            <Flex
                alignItems="center"
                css={{
                    backgroundColor: backgroundColor ?? '$white',
                    border: '1px solid',
                    borderColor: borderColor ?? '$neutral100',
                    br: '$1',
                    p: '$3',
                    ...(onClick !== undefined && { cursor: 'pointer' }),
                }}
                justifyContent="space-between"
                onClick={onClick}
            >
                {startContent}
                {endContent}
            </Flex>
            {helperText && (
                <Text
                    size="xs"
                    css={{
                        color: '$neutral500',
                        px: '$3',
                    }}
                >
                    {helperText}
                </Text>
            )}
        </StyledAppSection>
    )
)

AppSection.displayName = 'AppSection'

export default AppSection
export { StyledAppSection }
